import { render, staticRenderFns } from "./BiggestInfluencers.vue?vue&type=template&id=4144b0da&scoped=true"
import script from "./BiggestInfluencers.vue?vue&type=script&lang=ts"
export * from "./BiggestInfluencers.vue?vue&type=script&lang=ts"
import style0 from "./BiggestInfluencers.vue?vue&type=style&index=0&id=4144b0da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4144b0da",
  null
  
)

export default component.exports